import DateFnsUtils from "@date-io/date-fns";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { FormControl } from "@material-ui/core";
import { ptBR } from "date-fns/locale";
import { RiCalendar2Line } from "react-icons/ri";
import { isset } from "../utils/Utils";

const CustomDatePicker = ({ variant, inputVariant, format, mask, label, margin, name, handleBlur, handleChange, value, error, errors, touched, helperText, placeholder, required, disabled, maxDate, minDate, inputProps, InputProps, style, inheritLabel, shouldDisableDate, labelLikePlaceholder, hideIcon, views }) => {
    return (
        <div className="d-flex flex-column gap-8">
            {label && !inheritLabel && !isset(labelLikePlaceholder) && (
                <span title={label} className="tt-14 medium color-white overflow-ellipsis w-100" htmlFor={name}>
                    {label}
                    {required ? <span className="color-red"> *</span> : ""}
                </span>
            )}

            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                <FormControl fullWidth>
                    <KeyboardDatePicker
                        autoOk
                        views={views ?? ["date", "month", "year"]}
                        label={(inheritLabel || isset(labelLikePlaceholder)) && label && (isset(labelLikePlaceholder) ? labelLikePlaceholder && !value : 1) ? label : null}
                        variant={variant ?? "inline"}
                        inputVariant={inputVariant ?? "outlined"}
                        mask={mask || "__/__/____"}
                        format={format ?? "dd/MM/yyyy"}
                        margin={margin ?? "dense"}
                        id={name}
                        name={name}
                        placeholder={placeholder}
                        helperText={helperText || (name && touched[name]) ? errors[name] : null}
                        error={error ?? (name ? Boolean(touched[name] && errors[name]) : false)}
                        value={value}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={disabled}
                        required={required}
                        maxDate={maxDate}
                        minDate={minDate}
                        shouldDisableDate={shouldDisableDate}
                        keyboardIcon={hideIcon ? <></> : <RiCalendar2Line color="#6B7280" />}
                        PopoverProps={{
                            anchorOrigin: { vertical: "bottom", horizontal: "right" },
                            transformOrigin: { vertical: "top", horizontal: "right" },
                        }}
                        style={{ margin: 0, marginTop: inheritLabel ? 24 : 0, ...style }}
                        inputProps={inputProps}
                        InputProps={InputProps}
                        InputLabelProps={{
                            shrink: isset(labelLikePlaceholder) ? !labelLikePlaceholder : undefined,
                        }}
                    />
                </FormControl>
            </MuiPickersUtilsProvider>
        </div>
    );
};

export default CustomDatePicker;
